import { useStore } from '@/models'
import { GameScreen } from '@/screens/new-design'
import { RootLayout } from '../../_layout'

export default function () {
  const {
    game: { setWalkthroughType }
  } = useStore()
  setWalkthroughType('DealTheFlop')
  return (
    <RootLayout>
      <GameScreen />
    </RootLayout>
  )
}
